import { useSyncExternalStore } from "react";

let state = { image: null };
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

export function openPhotoLightbox(src, alt = "Uploaded photo") {
  if (!src) return;
  state = { image: { src, alt } };
  emit();
}

export function closePhotoLightbox() {
  if (!state.image) return;
  state = { image: null };
  emit();
}

export function usePhotoLightbox() {
  const { image } = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return {
    lightbox: image,
    openLightbox: openPhotoLightbox,
    closeLightbox: closePhotoLightbox,
  };
}
